import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IReduxRequestNode } from "@litres-libs/types";
import { Request } from "../../../request/Request";
import type { RootState } from "../../../store";
import { getGlobalHeaders } from "../../browser/browserSlice";
import { addHydrateReducer } from "../../../utils/hydrateReducer";

interface ITakeState {
  actions: {
    takeBookCSRF: IReduxRequestNode<
      ITakeBookCSRFRequest,
      ITakeBookCSRFResponse
    >;
  };
  rating: any[]; // Пока неизвестно в каком формате рейтинг будет храниться в сторе
}

const initialState: ITakeState = {
  actions: {
    takeBookCSRF: {},
  },
  rating: [],
};

interface ITakeBookCSRFRequest {
  action: string;
  art: number;
  a_url: string;
  gu_ajax: true;
}

interface ITakeBookCSRFResponse {
  status: string;
}

/**
 * По нажатию на кнопку "Взять себе"
 */
export const takeBookCSRF = createAsyncThunk(
  "global/book/takeBook",
  async (
    params: {
      art_id: number;
      art_url: string;
      onSuccess?: () => void;
      onError?: () => void;
    },
    { getState }
  ) => {
    const response = new Request.CSRF<
      ITakeBookCSRFRequest,
      ITakeBookCSRFResponse
    >({
      url: "/pages/ajax_empty2/",
      provider: {
        id: "TAKE_BOOK",
      },
      request: {
        method: "POST",
        data: {
          action: "decr_user_gifts",
          art: params.art_id,
          a_url: params.art_url,
          gu_ajax: true,
        },
      },
      headers: {
        ...getGlobalHeaders(getState() as RootState),
      },
      onSuccess: params.onSuccess,
      onError: params.onError,
    });

    return await response.fetch();
  }
);

export const takeSlice = createSlice({
  name: "pages/global/take",
  initialState,
  reducers: {
    setTakenBook: () => {
      // Нужна ли нам запись в сторе для этого?
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "global.take.take");
    /**
     * Обработка загрузки и ответа при получении данных
     */
    builder.addCase(takeBookCSRF.pending, (state: ITakeState) => {
      state.actions.takeBookCSRF.isLoading = true;
      state.actions.takeBookCSRF.error = undefined;
    });
    builder.addCase(
      takeBookCSRF.fulfilled,
      (
        state: ITakeState,
        action: PayloadAction<
          IReduxRequestNode<ITakeBookCSRFRequest, ITakeBookCSRFResponse>
        >
      ) => {
        state.actions.takeBookCSRF = action.payload;
        state.actions.takeBookCSRF.isLoading = false;
      }
    );
  },
});

export const { setTakenBook } = takeSlice.actions;

export default takeSlice.reducer;
